export const AUTH_USER = 'user';
